import styled, { css } from 'styled-components'

interface StyledWrapperProps {
  $minWidth?: string
  $maxWidth?: string
  $width?: string
}

export const StyledWrapper = styled.div<StyledWrapperProps>(({
  theme: {
    corners, palette,
  }, $maxWidth, $minWidth, $width,
}) => css`
    display: flex;
    flex-direction: column;
    border-radius: ${corners.overview.borderRadius};
    border: 1px solid ${palette.gray.light};
    background-color: ${palette.light.white};
    padding: 1.5rem;
    gap: 0.5rem;
    ${$minWidth && css`min-width: ${$minWidth};`}
    ${$maxWidth && css`max-width: ${$maxWidth};`}
    ${$width && css`width: ${$width};`}
  `)

export const TitleWrapper = styled.div(({
  theme: {
    typography, palette,
  },
}) => css`
    font-size: ${typography.tiny.pt_12_medium.fontSize};
    font-weight: ${typography.tiny.pt_12_medium.fontWeight};
    color: ${palette.dark.normal};
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    align-items: center;
  `)
